import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrSelectComponent } from './pr-select.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, MatSelectModule],
  exports: [PrSelectComponent],
  declarations: [PrSelectComponent],
})
export class PrSelectModule {}
